var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-empty-state',{staticClass:"md-primary md-small",attrs:{"md-icon":"done","md-label":"Done","md-description":"We have received your booking request. We'll contact you shortly. Thank you!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }